import React from 'react';
import FormError from '../../../../components/form/error/error';
import { ShowUnTouchedConsumer } from '../../context';

const SSMFieldWrapper = (props) => {
  const {
    EditField,
    config,
    id,
    customClass = '',
  } = props;

  const accumulatedFieldProps = {
    id,
    value: config.state[id] ? config.state[id] : '',
    ...config.authorableContent[id],
    onBlur: config.onBlurFunction,
    onChange: config.onChangeFunction,
  };
  const hasError = config.hasErrors[id] && (config.hasErrors[id].invalid === undefined ? true : config.hasErrors[id].invalid);
  // True if the input has validation and has not been touched
  const isUntouched = !(config.hasErrors[id] && config.hasErrors[id].touched);
  const errorText = config.authorableContent[id].errorText;
  const editField = React.cloneElement(<EditField />, accumulatedFieldProps);
  return (
    <React.Fragment>
      {/* Consumes the context of whether to show untouched input errors with the bool showUntouchedErrors */}
      <ShowUnTouchedConsumer>
        {showUntouchedErrors => (
          <div
            className={`${customClass} ${id} ${isUntouched ? 'untouched' : ''}
             ${(isUntouched && showUntouchedErrors === true) || hasError ? 'has-error' : ''} `}
          >
            {editField}
            {(((isUntouched && showUntouchedErrors === true) || hasError) && errorText) && <FormError errorText={errorText} />}
          </div>
        )}
      </ShowUnTouchedConsumer>
    </React.Fragment>
  );
};

export default SSMFieldWrapper;
